import { render, staticRenderFns } from "./SidebarC.vue?vue&type=template&id=06295bae"
import script from "./SidebarC.vue?vue&type=script&lang=js"
export * from "./SidebarC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports